import Vue from 'vue';

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script = {
  name: 'VsAlert',

  props: {
    // Variants: success, warning, error, info, secondary
    variant: {
      type: String,
      required: true,
      validator: value => ['success', 'error', 'info', 'warning', 'secondary'].includes(value.toLowerCase()),
    },
    showClose: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    noBg: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    toast: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classList() {
      return [
        `vs-alert-${this.variant}`,
        { 'vs-alert--no-bg': this.noBg },
        { 'vs-alert--small': this.small },
        { 'vs-alert--toast': this.toast },
        { 'vs-alert--is-close': this.showClose },
      ];
    },
  },
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { class: ["vs-alert", _vm.classList] },
    [
      _c(
        "span",
        { staticClass: "vs-alert-icon__wrapper" },
        [
          _vm._t("icon", [
            _vm.variant === "success"
              ? _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "16",
                      height: "16",
                      viewBox: "0 0 16 16",
                      role: "presentation",
                      focussable: "false"
                    }
                  },
                  [
                    _c(
                      "g",
                      {
                        attrs: {
                          fill: "none",
                          stroke: "var(--vs-alert-success-icon)"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            d: "M4 9l2.5 2.5 5-5"
                          }
                        }),
                        _vm._v(" "),
                        _c("circle", {
                          attrs: { cx: "7.5", cy: "8.5", r: "7" }
                        })
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.variant === "warning"
              ? _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "16",
                      height: "16",
                      viewBox: "0 0 16 16",
                      role: "presentation",
                      focussable: "false"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        fill: "none",
                        stroke: "var(--vs-alert-warning-icon)",
                        "stroke-linecap": "round",
                        d:
                          "M.88 13.77L7.06 1.86c.19-.36.7-.36.89 0l6.18 11.91c.17.33-.07.73-.44.73H1.32c-.37 0-.61-.4-.44-.73zM7.5 6v3.5"
                      }
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: { cx: "7.5", cy: "12", r: "1", fill: "#ad5918" }
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.variant === "error"
              ? _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "16",
                      height: "16",
                      viewBox: "0 0 16 16",
                      role: "presentation",
                      focussable: "false"
                    }
                  },
                  [
                    _c(
                      "g",
                      {
                        attrs: {
                          fill: "none",
                          stroke: "var(--vs-alert-error-icon)"
                        }
                      },
                      [
                        _c("circle", {
                          attrs: { cx: "7.5", cy: "8.5", r: "7" }
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: { "stroke-linecap": "round", d: "M7.5 4.5V9" }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: {
                        cx: "7.5",
                        cy: "12",
                        r: "1",
                        fill: "var(--vs-alert-error-icon)"
                      }
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.variant === "info"
              ? _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "16",
                      height: "16",
                      viewBox: "0 0 16 16",
                      role: "presentation",
                      focussable: "false"
                    }
                  },
                  [
                    _c(
                      "g",
                      { attrs: { stroke: "var(--vs-alert-info-icon)" } },
                      [
                        _c("circle", {
                          attrs: { cx: "7.5", cy: "8.5", r: "7", fill: "none" }
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: { "stroke-linecap": "round", d: "M7.5 12.5V8" }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: {
                        cx: "7.5",
                        cy: "5",
                        r: "1",
                        fill: "var(--vs-alert-info-icon)"
                      }
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.variant === "secondary"
              ? _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "16",
                      height: "16",
                      viewBox: "0 0 16 16",
                      role: "presentation",
                      focussable: "false"
                    }
                  },
                  [
                    _c(
                      "g",
                      { attrs: { stroke: "var(--vs-alert-secondary-icon)" } },
                      [
                        _c("circle", {
                          attrs: { cx: "7.5", cy: "8.5", r: "7", fill: "none" }
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: { "stroke-linecap": "round", d: "M7.5 12.5V8" }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: {
                        cx: "7.5",
                        cy: "5",
                        r: "1",
                        fill: "var(--vs-alert-secondary-icon)"
                      }
                    })
                  ]
                )
              : _vm._e()
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "vs-alert__heading" },
        [_vm._t("title", [_vm.title ? [_vm._v(_vm._s(_vm.title))] : _vm._e()])],
        2
      ),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _vm.showClose
        ? _c(
            "button",
            {
              class: ["vs-alert-button", _vm.variant],
              attrs: { "aria-label": "Close" },
              on: {
                click: function($event) {
                  return _vm.$emit("close", true)
                }
              }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "12",
                    height: "12",
                    viewBox: "0 0 12 12",
                    role: "presentation",
                    focusable: "false"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      stroke: "currentColor",
                      "stroke-linecap": "round",
                      d: "M3 9l6-6m0 6L3 3"
                    }
                  })
                ]
              )
            ]
          )
        : _vm._e()
    ],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-b5696c94_0", { source: ".vs-alert {\n  --vs-alert-success-bc: #aecfc2;\n  --vs-alert-success-bg: #edf8f4;\n  --vs-alert-success-color: #186146;\n  --vs-alert-success-icon: #038153;\n  --vs-alert-warning-bc: #fed6a8;\n  --vs-alert-warning-bg: #fff7ed;\n  --vs-alert-warning-color: #ad5918;\n  --vs-alert-warning-icon: #ad5918;\n  --vs-alert-error-bc: #f5b5ba;\n  --vs-alert-error-bg: #fff0f1;\n  --vs-alert-error-color: #8c232c;\n  --vs-alert-error-icon: #cc3340;\n  --vs-alert-info-bc: #adcce4;\n  --vs-alert-info-bg: #edf7ff;\n  --vs-alert-info-color: #1f73b7;\n  --vs-alert-info-icon: #337fbd;\n  --vs-alert-secondary-bc: #d8dcde;\n  --vs-alert-secondary-bg: #f8f9f9;\n  --vs-alert-secondary-color: #68737d;\n  --vs-alert-secondary-icon: #68737d;\n  position: relative;\n  border-radius: 4px;\n  padding: 20px 20px 20px 40px;\n  line-height: 1.42857;\n  font-size: 14px;\n}\n.vs-alert-icon__wrapper svg {\n  position: absolute;\n  left: 15px;\n  margin-top: 1px;\n}\n.vs-alert__heading {\n  font-weight: 600;\n  filter: brightness(85%);\n}\n.vs-alert-button {\n  display: block;\n  position: absolute;\n  top: 15px;\n  right: 10px;\n  transition: background-color 0.1s ease-in-out 0s, color 0.25s ease-in-out 0s;\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n  padding: 0px;\n  width: 28px;\n  height: 28px;\n  overflow: hidden;\n  color: #333333;\n  font-size: 0px;\n  user-select: none;\n}\n.vs-alert-button.success {\n  color: var(--vs-alert-success-color);\n}\n.vs-alert-button.warning {\n  color: var(--vs-alert-warning-color);\n}\n.vs-alert-button.error {\n  color: var(--vs-alert-error-color);\n}\n.vs-alert-button.info {\n  color: var(--vs-alert-info-color);\n}\n.vs-alert-button.secondary {\n  color: var(--vs-alert-secondary-color);\n}\n.vs-alert-success {\n  border: 1px solid var(--vs-alert-success-bc);\n  background-color: var(--vs-alert-success-bg);\n  color: var(--vs-alert-success-color);\n}\n.vs-alert-warning {\n  border: 1px solid var(--vs-alert-warning-bc);\n  background-color: var(--vs-alert-warning-bg);\n  color: var(--vs-alert-warning-color);\n}\n.vs-alert-error {\n  border: 1px solid var(--vs-alert-error-bc);\n  background-color: var(--vs-alert-error-bg);\n  color: var(--vs-alert-error-color);\n}\n.vs-alert-info {\n  border: 1px solid var(--vs-alert-info-bc);\n  background-color: var(--vs-alert-info-bg);\n  color: var(--vs-alert-info-color);\n}\n.vs-alert-secondary {\n  border: 1px solid var(--vs-alert-secondary-bc);\n  background-color: var(--vs-alert-secondary-bg);\n  color: var(--vs-alert-secondary-color);\n}\n.vs-alert.vs-alert--small:not(.vs-alert--is-close) {\n  padding: 12px 20px 12px 40px;\n}\n.vs-alert.vs-alert--is-close:not(.vs-alert--small) {\n  padding: 20px 40px;\n}\n.vs-alert.vs-alert--is-close.vs-alert--small {\n  padding: 12px 40px;\n}\n.vs-alert.vs-alert--is-close.vs-alert--small .vs-alert-button {\n  top: 8px;\n}\n.vs-alert--no-bg {\n  background-color: transparent;\n  border-color: transparent;\n  padding: 0 22px;\n  font-size: 13px;\n}\n.vs-alert--no-bg .vs-alert-icon__wrapper svg {\n  left: 0;\n  margin-top: 0;\n}\n.vs-alert--no-bg.vs-alert-warning {\n  color: var(--vs-alert-warning-icon);\n}\n.vs-alert--no-bg.vs-alert-error {\n  color: var(--vs-alert-error-icon);\n}\n.vs-alert--toast {\n  background-color: transparent;\n  border: solid 1px #d8dcde;\n  color: #2f3941;\n  box-shadow: rgba(23, 73, 77, 0.15) 0px 20px 28px 0px;\n  padding: 15px 40px;\n}\n.vs-alert--toast .vs-alert__heading {\n  filter: brightness(100%);\n}\n.vs-alert--toast.vs-alert-success .vs-alert__heading {\n  color: var(--vs-alert-success-icon);\n}\n.vs-alert--toast.vs-alert-warning .vs-alert__heading {\n  color: var(--vs-alert-warning-icon);\n}\n.vs-alert--toast.vs-alert-error .vs-alert__heading {\n  color: var(--vs-alert-error-icon);\n}\n.vs-alert--toast.vs-alert-info .vs-alert__heading {\n  color: var(--vs-alert-info-icon);\n}\n.vs-alert--toast.vs-alert-secondary .vs-alert__heading {\n  color: var(--vs-alert-secondary-icon);\n}\n.vs-alert--toast .vs-alert-button {\n  color: #68737d;\n  top: 10px;\n}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

//

var script$1 = {
  name: 'VsToast',

  props: {
    type: {
      type: String,
      default: 'toast',
    },
    /**
     * Toast title
     */
    title: {
      type: String,
    },
    /**
     * Toast message
     */
    message: {
      type: String,
    },
    /**
     * Toast Variants (same as vs-alert)
     * Variants: success, warning, error, info, secondary
     */
    variant: {
      type: String,
    },
    /**
     * Show Toast Close Icon
     */
    showClose: {
      type: Boolean,
      default: true,
    },
    /**
     * Position of toast:
     * top-left, top-center, top-right, bottom-left, bottom-center, bottom-right
     */
    position: {
      type: String,
      default: 'top-center',
      validator: value =>
        ['top-left', 'top-center', 'top-right', 'bottom-left', 'bottom-center', 'bottom-right'].includes(
          value.toLowerCase(),
        ),
    },
    /**
     * Animation name:
     * vs-toast--transition-{animation}
     */
    animation: {
      type: String,
    },
    /**
     * Toast Timeout
     */
    timeout: {
      type: Number,
      default: 5000,
    },
    /**
     * Whether toast should close automatically or not
     */
    isSticky: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    VsAlert: __vue_component__,
  },

  data() {
    return {
      isOpen: false,
      timerId: null,
      isMouseHovered: false,
      isTimedOut: false,
    };
  },

  computed: {
    /**
     * Main Class List
     * @returns {String} class
     */
    classList() {
      return [`vs-toast--${this.position}`];
    },

    /**
     * Toggle Transition Class
     * @returns {String} class
     */
    toggleTransition() {
      const position = this.position.split('-')[0];
      // If custom animation
      if (this.animation) {
        return `vs-toast--transition-${this.animation}`;
      }
      if (position === 'top') {
        return 'vs-toast--transition-slide-down';
      }
      return 'vs-toast--transition-slide-up';
    },
  },

  methods: {
    /**
     * Open Toast
     * If timer exists: reset and open
     */
    async open(options = {}) {
      if (Object.keys(options).length !== 0) {
        if (this.isOpen) {
          this.close();
          this.$nextTick(() => this.open(options));
          return;
        }
        options = { ...this.$props, ...options };
        Object.keys(options).forEach(field => (this[field] = options[field]));
      }

      if (this.timerId) {
        await this.close();
      }
      this.isOpen = true;
      this.isTimedOut = false;
      if (!this.isSticky) {
        this.timerId = setTimeout(async () => {
          if (!this.isMouseHovered) {
            await this.close();
          }
          this.isTimedOut = true;
        }, this.timeout);
      }
    },

    /**
     * Close Toast
     * Clear timerId and clearTimeout
     */
    close() {
      if (this.timerId) {
        clearTimeout(this.timerId);
        this.timerId = null;
      }
      this.isOpen = false;
      return new Promise(resolve =>
        setTimeout(() => {
          this.$emit('input', this.isOpen);
          resolve();
        }, 10),
      );
    },

    /**
     * On mouse hover on toast
     * Close only if timedOut and not hovered
     */
    mouseHover(value = false) {
      this.isMouseHovered = value;
      if (this.isTimedOut && !this.isMouseHovered) {
        this.close();
      }
    },

    /**
     * Emitted after transition is done and opened
     */
    onEnter() {
      this.$emit('reveal');
    },

    /**
     * Emitted after transition is done and closes
     */
    onLeave() {
      this.$emit('hide');
    },
  },
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "transition",
    {
      attrs: { name: _vm.toggleTransition },
      on: { "after-enter": _vm.onEnter, "after-leave": _vm.onLeave }
    },
    [
      _vm.isOpen
        ? _c(
            "div",
            {
              class: ["vs-toast", _vm.classList],
              attrs: { role: "status" },
              on: {
                mouseover: function($event) {
                  return _vm.mouseHover(true)
                },
                mouseleave: function($event) {
                  return _vm.mouseHover(false)
                }
              }
            },
            [
              _vm._t(
                "custom",
                [
                  _c(
                    "vs-alert",
                    {
                      attrs: {
                        title: _vm.title,
                        variant: _vm.variant,
                        "show-close": _vm.showClose,
                        toast: _vm.type === "toast"
                      },
                      on: { close: _vm.close }
                    },
                    [_vm._t("default", [_vm._v(_vm._s(_vm.message))])],
                    2
                  )
                ],
                { close: _vm.close }
              )
            ],
            2
          )
        : _vm._e()
    ]
  )
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = function (inject) {
    if (!inject) return
    inject("data-v-053a2fbe_0", { source: ".vs-toast {\n  position: fixed;\n  width: 350px;\n  max-width: 350px;\n  background-color: #ffffff;\n  z-index: 9999;\n  font-family: inherit;\n  text-align: left;\n}\n.vs-toast .vs-alert {\n  padding: 15px 40px;\n}\n.vs-toast .vs-alert .vs-alert-button {\n  top: 10px;\n}\n.vs-toast--top-center {\n  left: calc(50% - 175px);\n  top: 5px;\n}\n.vs-toast--top-left {\n  left: 5px;\n  top: 5px;\n}\n.vs-toast--top-right {\n  right: 5px;\n  top: 5px;\n}\n.vs-toast--bottom-center {\n  left: calc(50% - 175px);\n  bottom: 5px;\n}\n.vs-toast--bottom-left {\n  left: 5px;\n  bottom: 5px;\n}\n.vs-toast--bottom-right {\n  right: 5px;\n  bottom: 5px;\n}\n.vs-toast--transition-slide-down-enter-active, .vs-toast--transition-slide-down-leave-active {\n  transition: 0.3s all ease-in-out;\n}\n.vs-toast--transition-slide-down-enter-to, .vs-toast--transition-slide-down-leave {\n  opacity: 1;\n  transform: translateY(0px);\n}\n.vs-toast--transition-slide-down-enter, .vs-toast--transition-slide-down-leave-to {\n  opacity: 0;\n  transform: translateY(-30px);\n}\n.vs-toast--transition-slide-up-enter-active, .vs-toast--transition-slide-up-leave-active {\n  transition: 0.3s all ease-in-out;\n}\n.vs-toast--transition-slide-up-enter-to, .vs-toast--transition-slide-up-leave {\n  opacity: 1;\n  transform: translateY(0px);\n}\n.vs-toast--transition-slide-up-enter, .vs-toast--transition-slide-up-leave-to {\n  opacity: 0;\n  transform: translateY(30px);\n}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    createInjector,
    undefined,
    undefined
  );

const variant = ['success', 'warning', 'error', 'info', 'secondary'];

const defaultOptions = {
  title: '',
  message: '',
  variant: 'success',
  position: 'top-center',
  type: 'toast',
  timeout: 5000,
  showClose: true,
  isSticky: false,
};

let toastCmp = null;

function createToastCmp() {
  const cmp = new Vue(__vue_component__$1);
  document.body.appendChild(cmp.$mount().$el);
  return cmp;
}

function getToastCmp() {
  if (!toastCmp) {
    toastCmp = createToastCmp();
  }
  return toastCmp;
}

function show(options = {}) {
  getToastCmp().open({ ...defaultOptions, ...options });
}

function close() {
  getToastCmp().close();
}

function createShorthands() {
  const shorthands = {};
  variant.forEach(variant => (shorthands[variant] = (message, options = {}) => show({ variant, message, ...options })));
  return shorthands;
}

var index = {
  show,
  close,
  getToastCmp,
  defaultOptions,
  ...createShorthands(),
};

export default index;
